import HttpCliente from "../servicios/HttpCliente";

export const registrarUsuario = (usuario) => {
  return new Promise((resolve) => {
    HttpCliente.post("/user/register", usuario).then((response) => {
      resolve(response);
    });
  });
};

export const obtenerUsuarioActual = (dispatch) => {
  return new Promise((resolve) => {
    HttpCliente.getWithConfig("/user", { skipAuthRedirect: true })
      .then((response) => {
        if (response.data && response.data.imagenPerfil) {
          let fotoPerfil = response.data.imagenPerfil;
          const nuevoFile = 'data:image/' + fotoPerfil.extension + ';base64,' + fotoPerfil.data;
          response.data.imagenPerfil = nuevoFile;
        }

        dispatch({
          type: "INICIAR_SESION",
          sesion: response.data,
          autenticado: true,
        });
        resolve(response);
      })
      .catch((error) => {
        resolve(error);
      });
  });
};

export const actualizarUsuario = (usuario, dispatch) => {
  return new Promise((resolve) => {
    HttpCliente.put("/user", usuario)
      .then(response => {
        if (response.data && response.data.imagenPerfil) {
          let fotoPerfil = response.data.imagenPerfil;
          const nuevoFile = 'data:image/' + fotoPerfil.extension + ';base64,' + fotoPerfil.data;
          response.data.imagenPerfil = nuevoFile;
        }

        dispatch({
          type: 'INICIAR_SESION',
          sesion: response.data,
          autenticado: true,
        });

        resolve(response);

      })
      .catch(error => {
        resolve(error.response);
      })
  });
};

export const loginUsuario = (usuario, dispatch) => {
  return new Promise((resolve) => {
    HttpCliente.post("/user/login", usuario).then(response => {
      if (response.data && response.data.imagenPerfil) {
        let fotoPerfil = response.data.imagenPerfil;
        const nuevoFile = "data:image/" + fotoPerfil.extension + ";base64," + fotoPerfil.data;
        response.data.imagenPerfil = nuevoFile;
      }

      dispatch({
        type: "INICIAR_SESION",
        sesion: response.data,
        autenticado: true
      })

      resolve(response);
    }).catch(error => {
      resolve(error.response);
    });
  });
};
